<template>
  <form class="ucar-section" :class="{ 'disabled': disabled }">
    <div class="ucar-section-title" v-if="title">{{title}}</div>
    <fieldset class="ucar-section-content" :disabled="disabled">
      <slot></slot>
    </fieldset>
  </form>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.ucar-section {
  margin-bottom: 20px;
  color: $ucar_font_color;
  background: #fff;

  .photo-info + & {
    margin-top: 20px;
  }

  &:last-of-type {
    margin-bottom: auto;
  }

  &.disabled {
    pointer-events: none;
    opacity: .5;
  }

  .ucar-section-title {
    height: 100px;
    line-height: 100px;
    padding: 0 30px;
    color: $ucar_font_color;
    font-size: $ucar_font_h4;
    font-weight:550;
    border-bottom: 1PX solid $ucar_light_border; /*no*/
  }

  .ucar-section-content {
    position: relative;
    background-color: #fff;
    padding: 0 30px;
    .row-info label{
      // color:#8c8b8b;
    }
    .row-info .value.error{
      color:$ucar_label_color
    }
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
